export type Id = string
export type EntityId = Id

export interface Entity {
  id: EntityId
  createdAt: Date
  deletedAt?: Date
}

export enum EntityFields {
  ID = 'id',
  CREATED_AT = 'createdAt',
  DELETED_AT = 'deletedAt',
}

export interface Paging {
  from?: number
  count?: number
}

export interface PaginatedResult<T> {
  from: number
  count: number
  total: number
  items: T[]
}

export function mapPaginatedResult<T>(
  response: PaginatedResult<T>,
  mapper: (obj: T) => unknown,
): PaginatedResult<unknown> {
  return {
    ...response,
    items: response.items.map(mapper),
  } satisfies PaginatedResult<unknown>
}

export enum OrderDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export interface Order<PossibleFields> {
  field: PossibleFields
  direction: OrderDirection
}
